// import React, { useContext, useEffect, useState } from "react";
// import { Link as RouterLink } from "react-router-dom";
// import axios from "axios";
// import Lottie from "lottie-react";
// import Preloader from "../../../../Preloader/Preloader-Animation.json";
// import { useAuthHeaders } from "../../../../components/Token";
// import { API_BASE_URL } from "../../../../utils/index";

// import {
//   Box,
//   Typography,
//   Button,
//   IconButton,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   Paper,
//   Tooltip,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   Snackbar,
//   Alert,
//   TablePagination,
// } from "@mui/material";

// import VisibilityIcon from "@mui/icons-material/Visibility";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import ToggleOnIcon from "@mui/icons-material/ToggleOn";
// import ToggleOffIcon from "@mui/icons-material/ToggleOff";
// import { GetVendorCategory } from "../../../../services/api/Category";
// import { DELETEsubcategory, GetVendorsubcategory, UpdatestatusVendorsubcategory } from "../../../../services/api/Subcategory";
// import userContext from "../../../../components/UseContext/UseContext";

// function VendorSubCategorys() {
//   const [data, setData] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const headers = useAuthHeaders();
//   const [loading, setLoading] = useState(true);

//   const [openDialog, setOpenDialog] = useState(false);
//   const [selectedCategoryId, setSelectedCategoryId] = useState(null);
//   const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
//   const subdomain = localStorage.getItem("vendorsubdomain")
//   // Pagination
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const { permissionvalues } = useContext(userContext);
//   const
//     permissions = permissionvalues?.permissions?.master.subCategory

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         setLoading(true);
//         const [categoriesResponse, subcategoriesResponse] = await Promise.all([
//           await GetVendorCategory(subdomain),
//           await GetVendorsubcategory(subdomain)
//         ]);

//         console.log(categoriesResponse, "subcategoriesResponse")
//         console.log(subcategoriesResponse, "subcategoriesResponse")
//         setCategories(categoriesResponse?.
//           categories
//         );
//         setData(subcategoriesResponse?.subcategories);
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, []);

//   const handleDelete = async () => {
//     if (!selectedCategoryId) return;

//     try {

//       const response = await DELETEsubcategory(subdomain, selectedCategoryId)
//       if (response.success) {

//         setData((prevData) => prevData?.filter((item) => item._id !== selectedCategoryId));
//         setSnackbar({ open: true, message: "Subcategory deleted successfully!", severity: "success" });
//       } else {

//         setSnackbar({ open: true, message: "Error deleting subcategory", severity: "error" });
//       }
//     } catch (error) {
//       console.log(error)
//     }
//     finally {
//       setOpenDialog(false);
//       setSelectedCategoryId(null);
//     }

//   };

//   const toggleCategoryStatus = async (categoryId, isActive) => {
//     try {

//       const payload = { isActive: !isActive }
//       const response = await UpdatestatusVendorsubcategory(subdomain, payload, categoryId)
//       if (response.success) {
//         setData((prevData) =>
//           prevData.map((item) =>
//             item._id === categoryId ? { ...item, isActive: !isActive } : item
//           )
//         );
//         setSnackbar({ open: true, message: "Status updated!", severity: "success" });
//       } else {
//         setSnackbar({
//           open: true,
//           message: response?.data?.error || "Error updating status",
//           severity: "error",
//         });
//       }
//     } catch (error) {

//       console.log(error, "errros")

//     }


//   };

//   const handleChangePage = (_, newPage) => setPage(newPage);
//   const handleChangeRowsPerPage = (e) => {
//     setRowsPerPage(parseInt(e.target.value, 10));
//     setPage(0);
//   };

//   const paginatedData = data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

//   return (
//     <Box p={3}>
//       <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//         <Typography variant="h5" fontWeight={600}>
//           Sub Categories
//         </Typography>

//         {permissions?.create &&
//           <Button variant="contained" component={RouterLink} to={`/${subdomain}/master/sub-category/create`}>
//             Add New
//           </Button>
//         }
//       </Box>
//       {permissions?.read && (

//         <Paper elevation={3}>
//           {loading ? (
//             <Box display="flex" justifyContent="center" alignItems="center" height="300px">
//               <Lottie animationData={Preloader} style={{ width: 200 }} />
//             </Box>
//           ) : (
//             <>
//               <Table>
//                 <TableHead sx={{ backgroundColor: "#f5f5f5" }}>
//                   <TableRow>
//                     <TableCell><strong>Sub Category</strong></TableCell>
//                     <TableCell><strong>Category</strong></TableCell>
//                     <TableCell><strong>Action</strong></TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {paginatedData.length > 0 ? (
//                     paginatedData.map((item) => (
//                       <TableRow key={item._id}>
//                         <TableCell>{item?.name}</TableCell>
//                         <TableCell>{item?.category?.name || "-"}</TableCell>
//                         <TableCell>
//                           {/* <Tooltip title="View">
//                           <IconButton component={RouterLink} to={`/subCategorysDetial/${item._id}`}>
//                             <VisibilityIcon />
//                           </IconButton>
//                         </Tooltip> */}
//                           {permissions?.edit &&
//                             <Tooltip title="Edit">
//                               <IconButton component={RouterLink} to={`/${subdomain}/master/sub-category/edit/${item._id}`}>
//                                 <EditIcon />
//                               </IconButton>
//                             </Tooltip>
//                           }
//                           {permissions?.delete &&
//                             < Tooltip title="Delete">
//                               <IconButton
//                                 onClick={() => {
//                                   setSelectedCategoryId(item._id);
//                                   setOpenDialog(true);
//                                 }}
//                               >
//                                 <DeleteIcon color="error" />
//                               </IconButton>
//                             </Tooltip>
//                           }
//                           <Tooltip title={item?.isActive ? "Deactivate" : "Activate"}>
//                             <IconButton onClick={() => toggleCategoryStatus(item._id, item.isActive)}>
//                               {item?.isActive ? (
//                                 <ToggleOnIcon color="success" />
//                               ) : (
//                                 <ToggleOffIcon color="disabled" />
//                               )}
//                             </IconButton>
//                           </Tooltip>
//                         </TableCell>
//                       </TableRow>
//                     ))
//                   ) : (
//                     <TableRow>
//                       <TableCell colSpan={3} align="center">
//                         No subcategories found.
//                       </TableCell>
//                     </TableRow>
//                   )}
//                 </TableBody>
//               </Table>


//               <TablePagination
//                 component="div"

//                 count={data.length}
//                 page={page}
//                 onPageChange={handleChangePage}
//                 rowsPerPage={rowsPerPage}
//                 onRowsPerPageChange={handleChangeRowsPerPage}
//                 rowsPerPageOptions={[5, 10, 25]}
//                 sx={{ display: "flex", justifyContent: "space-between" }}
//               />

//             </>
//           )}
//         </Paper>
//       )
//       }

//       {/* Delete Confirmation Dialog */}
//       <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
//         <DialogTitle>Confirm Delete</DialogTitle>
//         <DialogContent>
//           <DialogContentText>
//             Are you sure you want to delete this subcategory? This action cannot be undone.
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
//           <Button color="error" variant="contained" onClick={handleDelete}>
//             Delete
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Snackbar */}
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={4000}
//         onClose={() => setSnackbar({ ...snackbar, open: false })}
//         anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//       >
//         <Alert
//           onClose={() => setSnackbar({ ...snackbar, open: false })}
//           severity={snackbar.severity}
//           sx={{ width: "100%" }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box >
//   );
// }

// export default VendorSubCategorys;

import React, { useContext, useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import axios from "axios";
import Lottie from "lottie-react";
import Preloader from "../../../../Preloader/Preloader-Animation.json";
import { useAuthHeaders } from "../../../../components/Token";
import { API_BASE_URL } from "../../../../utils/index";
import {
  Box,
  Typography,
  Button,
  IconButton,
  Tooltip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Snackbar,
  Alert,
  Paper,
} from "@mui/material";

import {
  Visibility as VisibilityIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  ToggleOn as ToggleOnIcon,
  ToggleOff as ToggleOffIcon,
} from "@mui/icons-material";

import { DataGrid } from "@mui/x-data-grid";
import { GetVendorCategory } from "../../../../services/api/Category";
import {
  DELETEsubcategory,
  GetVendorsubcategory,
  UpdatestatusVendorsubcategory,
} from "../../../../services/api/Subcategory";
import userContext from "../../../../components/UseContext/UseContext";
import { BsToggleOff, BsToggleOn } from "react-icons/bs";

function VendorSubCategorys() {
  const [data, setData] = useState([]);
  const [categories, setCategories] = useState([]);
  const headers = useAuthHeaders();
  const [loading, setLoading] = useState(true);

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [pageSize, setPageSize] = useState(5);
  const subdomain = localStorage.getItem("vendorsubdomain");
  const { permissionvalues } = useContext(userContext);
  const permissions = permissionvalues?.permissions?.master?.subCategory;

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const [categoriesResponse, subcategoriesResponse] = await Promise.all([
          GetVendorCategory(subdomain),
          GetVendorsubcategory(subdomain),
        ]);

        setCategories(categoriesResponse?.categories || []);
        setData(subcategoriesResponse?.subcategories || []);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleDelete = async () => {
    if (!selectedCategoryId) return;
    try {
      const response = await DELETEsubcategory(subdomain, selectedCategoryId);
      if (response.success) {
        setData((prev) => prev.filter((item) => item._id !== selectedCategoryId));
        setSnackbar({
          open: true,
          message: "Subcategory deleted successfully!",
          severity: "success",
        });
      } else {
        setSnackbar({
          open: true,
          message: "Error deleting subcategory",
          severity: "error",
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setOpenDialog(false);
      setSelectedCategoryId(null);
    }
  };

  const toggleCategoryStatus = async (categoryId, isActive) => {
    try {
      const payload = { isActive: !isActive };
      const response = await UpdatestatusVendorsubcategory(subdomain, payload, categoryId);
      if (response.success) {
        setData((prevData) =>
          prevData.map((item) =>
            item._id === categoryId ? { ...item, isActive: !isActive } : item
          )
        );
        setSnackbar({ open: true, message: "Status updated!", severity: "success" });
      } else {
        setSnackbar({
          open: true,
          message: response?.data?.error || "Error updating status",
          severity: "error",
        });
      }
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const columns = [
    {
      field: "name",
      headerName: "Sub Category",
      flex: 1,
    },
    {
      field: "category",
      headerName: "Category",
      flex: 1,
      valueGetter: (params) => params.row?.category?.name || "-",
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        const item = params.row;
        const validation = item?.vendor ? true : false
        console.log(item, "item")
        return (
          <Box display="flex" gap={1}>
            {permissions?.edit && validation && (
              <Tooltip title="Edit">
                <IconButton
                  component={RouterLink}
                  to={`/${subdomain}/master/sub-category/edit/${item._id}`}
                >
                  <EditIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
            {permissions?.delete && validation && (
              <Tooltip title="Delete">
                <IconButton
                  onClick={() => {
                    setSelectedCategoryId(item._id);
                    setOpenDialog(true);
                  }}
                >
                  <DeleteIcon color="error" fontSize="small" />
                </IconButton>
              </Tooltip>
            )}

            {permissions?.edit && validation && (

              <Tooltip title={item?.isActive ? "Deactivate" : "Activate"}>
                <IconButton onClick={() => toggleCategoryStatus(item._id, item.isActive)}>
                  {item?.isActive ? (
                    <BsToggleOn color="green" />
                  ) : (
                    <BsToggleOff color="gray" />
                  )}
                </IconButton>
              </Tooltip>
            )}
          </Box>
        );
      },
    },
  ];

  return (
    <Box p={3}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h5" fontWeight={600}>
          Sub Categories
        </Typography>

        {permissions?.create && (
          <Button
            variant="contained"
            component={RouterLink}
            to={`/${subdomain}/master/sub-category/create`}
          >
            Add New
          </Button>
        )}
      </Box>
      {console.log(data, "data>>>>")}
      {permissions?.read && (
        <Paper elevation={3}>
          {loading ? (
            <Box display="flex" justifyContent="center" alignItems="center" height="300px">
              <Lottie animationData={Preloader} style={{ width: 200 }} />
            </Box>
          ) : (
            <DataGrid
              autoHeight
              rows={data}
              getRowId={(row) => row._id}
              columns={columns}
              pageSize={pageSize}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              rowsPerPageOptions={[5, 10, 25]}
              pagination
              disableRowSelectionOnClick
            />
          )}
        </Paper>
      )}

      {/* Delete Confirmation Dialog */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this subcategory? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
          <Button color="error" variant="contained" onClick={handleDelete}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default VendorSubCategorys;
